let card = $(".people-parallax .card")
card.on("click", function(){
	$(this).toggleClass("hovered")
})